<template>
  <div id="express" v-if="travels.length > 0">
    <Travel class="sized-top-20" v-for="travel in travels" :key="travel.key" v-bind:travel="travel"></Travel>
  </div>
  <div class="sized-top-20" v-else>
    <span
      class="text-bold"
    >Você não tem corridas em andamento, vamos começar? Clique em solicitar corrida</span>
  </div>
</template>

<script>
import { db } from "../configs/firebase.js";
import Travel from "../components/Travel.vue";

export default {
  name: "Express",
  data() {
    return {
      travels: [],
      q_express: null
    };
  },
  components: {
    Travel
  },
  computed: {
    user: function() {
      return this.$root.user;
    }
  },
  methods: {
    sortTravels() {
      this.travels.sort(function(x, y) {
        return y.data.dates.create - x.data.dates.create;
      });
    },
    getTravels() {
      try {
        this.q_express = db
          .ref("travels")
          .orderByChild("keys/user_stats")
          .startAt(this.user.uid + "___0")
          .endAt(this.user.uid + "___1");

        this.q_express.on("child_added", s => {
          if (s.exists()) {
            this.addTravel(s);
          }
        });

        this.q_express.on("child_changed", s => {
          if (s.exists()) {
            this.updateTravel(s);
          }
        });

        this.q_express.on("child_removed", s => {
          if (s.exists()) {
            this.removeTravel(s);
          }
        });
      } catch (e) {
        //console.log(e);
      }
    },
    addTravel(s) {
      try {
        let travel = {
          key: s.key
        };

        this.$set(travel, "data", s.val());

        this.travels.push(travel);
      } catch (e) {
        //console.log(e);
      } finally {
        this.sortTravels();
      }
    },
    updateTravel(s) {
      try {
        let travel = this.travels.find(x => x.key == s.key);
        if (travel != null) {
          this.$set(travel, "data", s.val());
        }
      } catch (e) {
        //console.log(e);
      } finally {
        this.sortTravels();
      }
    },
    removeTravel(s) {
      try {
        this.travels = this.travels.filter(x => x.key != s.key);
      } catch (e) {
        //console.log(e);
      } finally {
        this.sortTravels();
      }
    }
  },
  watch: {
    user() {
      this.getTravels();
    }
  },
  created() {
    this.getTravels();
  },
  beforeDestroy() {
    try {
      this.q_express.off("child_added");
      this.q_express.off("child_changed");
      this.q_express.off("child_removed");
    } catch (e) {
      //console.log(e);
    }
  }
};
</script>

<style>
#express {
  text-align: left;
  margin: 20px auto;
  max-width: 912px;
}

@media only screen and (max-width: 912px) {
  #express {
    width: 100%;
    padding: 0px;
  }
}
</style>